module.exports = __webpack_public_path__ + "85d12bd10bc39c2337131fea69faec29.svg";